export class CondicaoPagamento {
  codigo: string;
  nome: string;
  valor: string;
  descricao: string;

  erro: string;
  }

